export default "__VITE_ASSET__bf2ba5c7__"